import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MessageCircle, Users, ShoppingBag, Trophy, MessageSquare } from 'lucide-react';
import Navbar from '../components/Navbar';

const WhatsAppCommunityPage = () => {
  const groups = [
    {
      id: 1,
      name: 'תיאום משחקים טניס',
      description: 'תיאום משחקים לפי רמות - מצא שותפים לאימון',
      icon: Users,
      color: 'from-blue-500 to-blue-600',
      link: 'https://chat.whatsapp.com/G8bFY7cDuexKCfihNknRyY',
      emoji: '🎾'
    },
    {
      id: 2,
      name: 'ציוד טניס - קנייה ומכירה',
      description: 'קנייה ומכירה של ציוד חדש או יד שנייה',
      icon: ShoppingBag,
      color: 'from-green-500 to-green-600',
      link: 'https://chat.whatsapp.com/KWlfpYYJu7kJHXS5eMH1cR',
      emoji: '🛒'
    },
    {
      id: 3,
      name: 'תחרויות ועדכונים',
      description: 'עדכונים שוטפים על תחרויות קרובות ותוצאות',
      icon: Trophy,
      color: 'from-orange-500 to-orange-600',
      link: 'https://chat.whatsapp.com/B7xnF1EjblnAbv5ixZ9kuo',
      emoji: '🏆'
    },
    {
      id: 4,
      name: 'פורום טניס',
      description: 'חיים, נושמים ומדברים טניס - הפורום הכללי שלנו',
      icon: MessageSquare,
      color: 'from-purple-500 to-purple-600',
      link: 'https://chat.whatsapp.com/GlsP2SWG4PI4r034BSH6kE',
      emoji: '💬'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-blue-50">
      <Navbar />
      <div className="py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <MessageCircle className="w-12 h-12 text-green-600 animate-pulse" />
            <h1 className="text-4xl md:text-5xl font-black text-gray-900">
              קהילת הטניס בוואטסאפ
            </h1>
            <MessageCircle className="w-12 h-12 text-green-600 animate-pulse" />
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            הצטרפו לקבוצות הוואטסאפ הפעילות שלנו
            <br />
            תיאום משחקים, ציוד, תחרויות ופורום כללי
          </p>
        </div>

        {/* Info Card */}
        <Card className="mb-12 bg-gradient-to-r from-green-500 to-green-600 border-none text-white">
          <CardContent className="p-6">
            <div className="flex items-start gap-4">
              <div className="text-4xl">💚</div>
              <div>
                <h3 className="text-2xl font-bold mb-2">ברוכים הבאים לקהילה!</h3>
                <p className="text-lg opacity-90">
                  הקבוצות שלנו פעילות 24/7 עם מאות חברים שאוהבים טניס כמוך.
                  בחר את הקבוצה המתאימה לך והצטרף עכשיו!
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* WhatsApp Groups */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {groups.map((group) => {
            const Icon = group.icon;
            return (
              <Card 
                key={group.id} 
                className="overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className={`bg-gradient-to-r ${group.color} p-6 text-white`}>
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-4xl">{group.emoji}</span>
                    <Icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-2xl font-bold mb-2">{group.name}</h3>
                  <p className="text-sm opacity-90">{group.description}</p>
                </div>
                <CardContent className="p-6">
                  <a
                    href={group.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full"
                  >
                    <button className={`w-full bg-gradient-to-r ${group.color} text-white py-4 px-6 rounded-lg font-bold text-lg hover:opacity-90 transition-opacity flex items-center justify-center gap-3 shadow-lg`}>
                      <MessageCircle className="w-6 h-6" />
                      הצטרף לקבוצה
                      <span className="text-2xl">→</span>
                    </button>
                  </a>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Rules Section */}
        <Card className="bg-gradient-to-br from-blue-50 to-purple-50">
          <CardHeader>
            <CardTitle className="text-2xl flex items-center gap-2">
              <span className="text-3xl">📜</span>
              כללי הקבוצות
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="flex items-start gap-3">
              <span className="text-2xl">✅</span>
              <p className="text-gray-700">
                <strong>כבוד הדדי:</strong> התייחסו בכבוד לכל חברי הקבוצה
              </p>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-2xl">✅</span>
              <p className="text-gray-700">
                <strong>רלוונטיות:</strong> שמרו על תוכן רלוונטי לנושא הקבוצה
              </p>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-2xl">✅</span>
              <p className="text-gray-700">
                <strong>ללא ספאם:</strong> הימנעו משליחת הודעות שיווקיות לא רלוונטיות
              </p>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-2xl">✅</span>
              <p className="text-gray-700">
                <strong>שפה נאותה:</strong> השתמשו בשפה מכבדת וללא קללות
              </p>
            </div>
          </CardContent>
        </Card>

        {/* Contact CTA */}
        <Card className="mt-12 bg-gradient-to-r from-green-600 to-blue-600 border-none text-white">
          <CardContent className="p-8 text-center">
            <h2 className="text-3xl font-bold mb-4">יש שאלות?</h2>
            <p className="text-xl mb-6">
              צרו איתנו קשר לכל שאלה או בקשה
            </p>
            <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
              <a 
                href="tel:+972544822788"
                className="bg-white text-green-600 px-8 py-3 rounded-lg font-bold hover:bg-green-50 transition-colors inline-flex items-center gap-2"
              >
                📞 054-482-2788
              </a>
              <a 
                href="https://wa.me/972544822788?text=היי, יש לי שאלה לגבי קבוצות הוואטסאפ"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-green-600 px-8 py-3 rounded-lg font-bold hover:bg-green-50 transition-colors inline-flex items-center gap-2"
              >
                💬 שלח הודעה
              </a>
            </div>
          </CardContent>
        </Card>
      </div>
      </div>
    </div>
  );
};

export default WhatsAppCommunityPage;
